import script from "./SpvEmptyState.vue?vue&type=script&setup=true&lang=js"
export * from "./SpvEmptyState.vue?vue&type=script&setup=true&lang=js"

import "./SpvEmptyState.vue?vue&type=style&index=0&id=31a4f770&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31a4f770"]])

export default __exports__